module.exports = __webpack_public_path__ + "static/media/sales.742139e0.svg";